import {
  Button,
  Input,
  Select,
  HStack,
  VStack,
  Box,
  Text,
  useToast
} from '@chakra-ui/react';
import { FaCar } from "react-icons/fa";
import { useForm } from 'react-hook-form';
import { BoxTitle } from '@/components/BoxTitle';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import InputMask from 'react-input-mask';
import { RiSteering2Fill } from "react-icons/ri";

interface MotoristaFormData {
  motorista: string;
  cpf: string;
  rg: string;
  celular: string;
  ativo: string;
  cep: string;
  endereco: string;
  numero: string;
  bairro: string;
  cidade: string;
  uf: string;
  tipoFuncionario: string;
  tipo: string;
  email: string;
}

interface ModalMotoristaProps {
  isOpen: boolean;
  onClose: () => void;
  handleAddMotorista: (formData: MotoristaFormData) => void;
}

const ModalMotorista: React.FC<ModalMotoristaProps> = ({ isOpen, onClose, handleAddMotorista }) => {
  const toast = useToast();
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset
  } = useForm<MotoristaFormData>({
    defaultValues: {
      motorista: '',
      cpf: '',
      rg: '',
      celular: '',
      ativo: '',
      cep: '',
      endereco: '',
      numero: '',
      bairro: '',
      cidade: '',
      uf: '',
      tipoFuncionario: '',
      tipo: '',
      email: ''
    }
  });

  const onSubmit = async (data: MotoristaFormData) => {
    const missingFields: string[] = [];

    Object.entries(data).forEach(([key, value]) => {
      if (!value.trim()) missingFields.push(key);
    });

    if (missingFields.length > 0) {
      toast({
        title: missingFields.length === 1
          ? `O campo ${missingFields[0]} é obrigatório.`
          : "Faltam campos obrigatórios a serem preenchidos.",
        status: "error",
        isClosable: true,
      });
      return;
    }

    handleAddMotorista(data);
    toast({
      title: "Motorista adicionado com sucesso!",
      status: "success",
      isClosable: true,
    });
    reset();
    onClose();
  };

  return (
    <ModalAlert
      isOpen={isOpen}
      onClose={onClose}
      size='3xl'
      title={<Text fontSize={'xl'} ml={2}>Motorista</Text>}
      body={
        <Box as="form" onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={4} align="stretch">
            <BoxTitle title="Motorista">
              <Input name="motorista" value={watch("motorista")} onChange={(e) => setValue("motorista", e.target.value)} placeholder="Insira o nome do motorista" />
            </BoxTitle>
            <HStack>
              <BoxTitle title="CPF">
                <Input as={InputMask} mask="999.999.999-99" name="cpf" value={watch("cpf")} onChange={(e) => setValue("cpf", e.target.value)} placeholder="Digite um CPF" />
              </BoxTitle>
              <BoxTitle title="RG">
                <Input as={InputMask} mask="99.999.999-9" name="rg" value={watch("rg")} onChange={(e) => setValue("rg", e.target.value)} placeholder="Digite um RG" />
              </BoxTitle>
              <BoxTitle title="Celular">
                <Input as={InputMask} mask="(99) 99999-9999" name="celular" value={watch("celular")} onChange={(e) => setValue("celular", e.target.value)} placeholder="Digite um celular" />
              </BoxTitle>
              <HStack w={'18%'}>
                <BoxTitle title="Ativo">
                  <Select name="ativo" value={watch("ativo")} onChange={(e) => setValue("ativo", e.target.value)}>
                    <option>Ativo</option>
                    <option>Inativo</option>
                  </Select>
                </BoxTitle>
              </HStack>
            </HStack>
            <HStack>
              <HStack w={'20%'}>
                <BoxTitle title="CEP">
                  <Input name="cep" value={watch("cep")} onChange={(e) => setValue("cep", e.target.value)} placeholder="Digite um CEP" />
                </BoxTitle>
              </HStack>
              <BoxTitle title="Endereço">
                <Input name="endereco" value={watch("endereco")} onChange={(e) => setValue("endereco", e.target.value)} placeholder="Digite um endereço" />
              </BoxTitle>
              <HStack w={'20%'}>
                <BoxTitle title="N°">
                  <Input name="numero" value={watch("numero")} onChange={(e) => setValue("numero", e.target.value)} placeholder="Número" />
                </BoxTitle>
              </HStack>
            </HStack>
            <HStack>
              <BoxTitle title="Bairro">
                <Input name="bairro" value={watch("bairro")} onChange={(e) => setValue("bairro", e.target.value)} placeholder="Digite um bairro" />
              </BoxTitle>
              <BoxTitle title="Cidade / IBGE">
                <Select name="cidade" value={watch("cidade")} onChange={(e) => setValue("cidade", e.target.value)} placeholder="Selecione uma cidade" />
              </BoxTitle>
              <HStack w={'20%'}>
                <BoxTitle title="UF">
                  <Input name="uf" value={watch("uf")} onChange={(e) => setValue("uf", e.target.value)} placeholder="UF" />
                </BoxTitle>
              </HStack>
            </HStack>
            <HStack>
              <BoxTitle title="Tipo funcionário">
                <Select name="tipoFuncionario" value={watch("tipoFuncionario")} onChange={(e) => setValue("tipoFuncionario", e.target.value)} placeholder="Selecione um tipo" />
              </BoxTitle>
              <BoxTitle title="Tipo">
                <Select name="tipo" value={watch("tipo")} onChange={(e) => setValue("tipo", e.target.value)} placeholder="Tipo" />
              </BoxTitle>
              <BoxTitle title="E-mail">
                <Input name="email" value={watch("email")} onChange={(e) => setValue("email", e.target.value)} placeholder="Digite um e-mail" />
              </BoxTitle>
            </HStack>
          </VStack>
        </Box>
      }
      footer={
        <Button colorScheme="blue" onClick={handleSubmit(onSubmit)}>
          Confirmar
        </Button>
      }
    />
  );
};

export default ModalMotorista;
